
/**
 * A custom element that renders a paginated blog posts list
 */
export default class CustomVariantPicker extends HTMLElement {
    connectedCallback() {
        if(this.hasAttribute('data-async-variant-picker')){
            this.handleVariantChange();
        }
    }
    handleVariantChange() {
        const that = this
        const variantPickerButtons = this.querySelectorAll('[data-product-card-variant-picker]');
        variantPickerButtons.forEach((button) => {
        button.addEventListener('click', function (event) {
            const productCard = button.closest('product-card');
            if (productCard) {
            const { currentTarget } = event;
            if (!(currentTarget instanceof HTMLElement)) return;
            const variantListItems = [...productCard.querySelectorAll('[data-custom-variant-picker-item]')];
            variantListItems.forEach((item) => {
                item.classList.remove('selected');
            });
            const closestListItem = currentTarget?.closest('[data-custom-variant-picker-item]');
            closestListItem?.classList.add('selected');
            const cardGallery = productCard.querySelector('[data-custom-variant-picker="product-card-gallery"]');
            if (!(cardGallery instanceof HTMLElement)) return;
            cardGallery.classList.add('loading');
            const productCardEls = [...productCard.querySelectorAll('[data-custom-variant-picker]')];
            event.preventDefault();
            const url = button.getAttribute('data-fetch-url');
            if (url) {
                fetch(url + '?view=product-card-variant-picker')
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newProductCard = doc.querySelector('product-card');
                    if (newProductCard) {
                    productCardEls.forEach((el) => {
                        const newEl = newProductCard.querySelector(
                        `[data-custom-variant-picker="${el.getAttribute('data-custom-variant-picker')}"]`
                        );
                        if (newEl) {
                        el.replaceWith(newEl);
                        }
                    });
                    that.handleVariantChange();
                    const link = productCard.querySelector('a.product-card__link');
                    if (link) {
                        link.setAttribute('href', url);
                    }
                }
                })
                .catch((error) => console.error('Error fetching variant picker:', error));
            }
            }
        });
        });
    }
}

if (!customElements.get('custom-variant-picker')) {
  customElements.define('custom-variant-picker', CustomVariantPicker);
}
